import { render } from "./facet-category.vue?vue&type=template&id=abc5d594&scoped=true&ts=true"
import script from "./facet-category.vue?vue&type=script&lang=ts"
export * from "./facet-category.vue?vue&type=script&lang=ts"

import "./facet-category.vue?vue&type=style&index=0&id=abc5d594&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abc5d594"]])

export default __exports__